import { FlatTreeControl } from '@angular/cdk/tree';
import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BoltMaterialModel, FlangeMaterialModel, GasketModel, GasketTypeModel } from 'src/app/Modules/informate/models';
import { TreeFlatNode } from 'src/app/Modules/informate/models/templatesModels/tree-flat-node';
import { TreeNode } from 'src/app/Modules/informate/models/templatesModels/tree-node';
import { MaterialAliasModel } from 'src/app/Modules/settings/models';

@Component({
    selector: 'app-material-list',
    templateUrl: './material-list.component.html',
    styleUrls: ['./material-list.component.scss'],
})
export class MaterialListComponent implements OnInit, AfterViewInit {
    @Input() flangeMaterialList: FlangeMaterialModel[];
    @Input() boltMaterialList: BoltMaterialModel[];
    @Input() materialAlias: MaterialAliasModel;
    @Input() gasketList: GasketModel[];
    @Input() gasketTypeList: GasketTypeModel[];
    @ViewChild(MatPaginator) paginator: MatPaginator;

    dataSourceFlangeMaterial: MatTableDataSource<FlangeMaterialModel>;
    dataSourceBoltMaterial: MatTableDataSource<BoltMaterialModel>;
    dataSourceMaterial: any;
    displayedColumns: string[] = ['id', 'position', 'type', 'design', 'composition', 'class'];
    pageSize = 5;
    currentPage = 0;
    totalSize = 0;
    private _transformer = (node: TreeNode, level: number) => {
        return {
            expandable: !!node.children && node.children.length > 0,
            name: node.name,
            id: node.id,
            level: level,
            typeId: node.typeId,
            typeName: node.typeName,
        };
    };

    treeControl = new FlatTreeControl<TreeFlatNode>(
        (node) => node.level,
        (node) => node.expandable
    );
    treeFlattener = new MatTreeFlattener(
        this._transformer,
        (node) => node.level,
        (node) => node.expandable,
        (node) => node.children
    );
    treedataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    hasChild = (_: number, node: TreeFlatNode) => node.expandable;
    gasketnodeList: TreeNode[];

    constructor(
        public ngbActiveModal: NgbActiveModal,
        private cd: ChangeDetectorRef
    ) { }

    ngOnInit(): void {


        switch (this.materialAlias.materialType.materialType || this.materialAlias.materialTypeId) {
            case 58:
                this.dataSourceBoltMaterial = new MatTableDataSource(this.boltMaterialList);
                this.dataSourceMaterial = this.dataSourceBoltMaterial;
                break;

            case 67:
                this.dataSourceFlangeMaterial = new MatTableDataSource(this.flangeMaterialList);
                this.dataSourceMaterial = this.dataSourceFlangeMaterial;
                break;

            case 68:
                // TODO Gaskets binding
                this.createTreeStructure();
                break;
        }
    }

    ngAfterViewInit(): void {
        if (this.materialAlias.materialType.materialType == 67 || this.materialAlias.materialType.materialType == 58) {
            this.dataSourceMaterial.paginator = this.paginator;
        }
    }

    applyFilter(event: any) {
        // let filterData = event.target.value;
        if (this.materialAlias.materialType.materialType == 67) {
            const filterValue = (event.target as HTMLInputElement).value;
            this.dataSourceFlangeMaterial.filter = filterValue.trim().toLowerCase();
            if (this.dataSourceFlangeMaterial.paginator) {
                this.dataSourceFlangeMaterial.paginator.firstPage();
            }
        } else if (this.materialAlias.materialType.materialType == 58) {
            const filterValue = (event.target as HTMLInputElement).value;
            this.dataSourceBoltMaterial.filter = filterValue.trim().toLowerCase();
            if (this.dataSourceBoltMaterial.paginator) {
                this.dataSourceBoltMaterial.paginator.firstPage();
            }
        }
    }

    selectItem(row: FlangeMaterialModel) {
        this.ngbActiveModal.close(row);
        this.cd.detectChanges();
    }

    createTreeStructure() {
        // let gasketTypeList  = this.gasketList.map((res) => res.gasketType);
        // gasketTypeList = [...new Set(gasketTypeList)];
        this.gasketnodeList = [];
        for (var gasket of this.gasketList) {
            let leafNode: TreeNode = {
                name: gasket.gasketName,
                id: gasket.gasketId,
                typeId: gasket.gasketType.gasketTypeId,
                typeName: gasket.gasketType.gasketTypeName,
            };

            if (gasket.gasketType.parentGasketTypeId == null) {
                let treeNode = this.gasketnodeList.find((x) => x.typeId == gasket.gasketType.gasketTypeId);

                if (treeNode == undefined) {
                    treeNode = { name: gasket.gasketType.gasketTypeName, typeId: gasket.gasketType.gasketTypeId, children: [leafNode] };
                    this.gasketnodeList.push(treeNode);
                } else {
                    treeNode.children.push(leafNode);
                }
            } else {
                let parent = this.gasketTypeList.find((x) => x.gasketTypeId == gasket.gasketType.parentGasketTypeId);

                let parentNode = this.gasketnodeList.find((x) => x.typeId == parent?.gasketTypeId);
                if (parentNode == undefined) {
                    let treeNode = { name: gasket.gasketType.gasketTypeName, typeId: gasket.gasketType.gasketTypeId, children: [leafNode] };
                    //when no Gasket type avaible than it skips
                    if (parent?.gasketTypeName != undefined) {
                        parentNode = { name: parent?.gasketTypeName, typeId: parent?.gasketTypeId, children: [treeNode] };
                        this.gasketnodeList.push(parentNode);
                    }
                } else {
                    let treeNode1 = parentNode.children.find((x) => x.typeId == gasket.gasketType.gasketTypeId);

                    if (treeNode1 == undefined) {
                        treeNode1 = { name: gasket.gasketType.gasketTypeName, typeId: gasket.gasketType.gasketTypeId, children: [leafNode] };
                        parentNode.children.push(treeNode1);
                    } else {
                        treeNode1.children.push(leafNode);
                    }
                }
            }
        }
        this.treedataSource.data = this.gasketnodeList;
        this.cd.detectChanges();
    }

    toggleOthers(node: TreeFlatNode) {
        if (node.level == 0) {
            if (this.treeControl.isExpanded(node)) {
                this.treeControl.collapseAll();
                this.treeControl.expand(node);
            } else {
                this.treeControl.collapseAll();
            }
        }
        if (node.level == 1 && node.expandable == true) {
            //TODO: Level 1 toggling
        }
    }

    selectedGasket(node) {
        // console.log(this.gasketList.find(x => x.gasketId === node.id));
        this.ngbActiveModal.close(this.gasketList.find((x) => x.gasketId === node.id));
        // this.gasketList.find(x => x.gasketId === node.id).qualifiedName;
    }
}
